module.exports = __webpack_public_path__ + "img/oltasok_kutya.17dcae2f.jpg";